import classNames from 'classnames';
import { func, node, string } from 'prop-types';
import * as styles from './SectionContainer.module.scss';

const SectionContainer = ({
  title,
  className = null,
  buttonText = null,
  onClickButton = () => {},
  dataTestId = null,
  children,
}) => {
  return (
    <div className={classNames(styles.sectionContainer, className)} data-testid={dataTestId}>
      <h2>
        {buttonText && (
          <button className={styles.actionButton} onClick={onClickButton}>
            {buttonText}
          </button>
        )}
        {title}
      </h2>
      {children}
    </div>
  );
};

SectionContainer.propTypes = {
  title: string,
  className: string,
  dataTestId: string,
  buttonText: string,
  onClickButton: func,
  children: node.isRequired,
};

export default SectionContainer;
